import axios from 'axios'
let config = localStorage.getItem("config") ? JSON.parse(localStorage.getItem("config")) : null;
axios.defaults.baseURL = config !== null ? `https://${config.servidor}:8004` : process.env.VUE_APP_API_URL;
//axios.defaults.baseURL = "http://roger.xcontactcenter.com.br"
axios.defaults.headers.common['Authorization'] = `Bearer 1e5a475b7421c20cf0edb60543b20d406a2e55fd2619f5f04ee10dbdc41a007b`;
console.log('API Plugin: ' + process.env.NODE_ENV);
console.log('baseURL: ' + axios.defaults.baseURL);
console.log(document.location);
console.log(process.env);

export default {
    http: axios,
    getToken: () => {
        return axios.defaults.headers.common['Authorization'];
    },
    setToken: (token) => {
        axios.defaults.headers.common['Authorization'] = token
    },
    unsetToken: () => {
        delete axios.defaults.headers.common['Authorization'];
    }
}